import { useQuery } from "@tanstack/react-query";
import { clienteService } from "@/services/api/cliente.service";

export function useFiliaisByCliente(clienteId?: number) {
  return useQuery({
    queryKey: ["filiais-by-cliente", clienteId],
    queryFn: () => clienteService.listFiliaisByClienteId(clienteId!),
    enabled: !!clienteId,
    staleTime: 1000 * 60 * 5,
  });
}
